// src/locale-init.ts
import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';

export function registerLocales() {
  registerLocaleData(localeDe, 'de', localeDeExtra);
}
